import { fileDownload } from 'utils/fileDownload';
import { logError } from 'utils/sentryUtils';

import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const weatherApi = {
    getReportOptions: async () => {
        const url = 'api/weather/v1/report/options';
        const response = await mmFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    createWeatherReport: async (orderSource, deliveryType, reportType) => {
        const data = {
            orderSource,
            deliveryType,
            reportType,
        };

        const url = 'api/weather/v1/report/new';
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(data),
        });
        return response;
    },
    getReportList: async () => {
        const url = 'api/weather/v1/reports';
        const response = await mmFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    downloadWeatherReport: async (reportID) => {
        const encodedReportID = encodeURIComponent(reportID);
        const url = `api/weather/v1/report/${encodedReportID}/download`;
        const filename = `weatherReport-${reportID}.csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, filename);
                return;
            }
            throw new Error('Failed to download weather report');
        } catch (e) {
            logError(e);
            throw e;
        }
    },
};

export { weatherApi };
